import { BillingPriceInterval } from '@tribeplatform/gql-client/types'
import { T } from '@tribeplatform/react-components/i18n'
import { useRouter } from '@tribeplatform/react-sdk'
import { Badge } from '@tribeplatform/react-ui-kit/Badge'
import { Card } from '@tribeplatform/react-ui-kit/Card'
import { Divider } from '@tribeplatform/react-ui-kit/Divider'

import { useCurrentProductInformation } from '../hooks/useCurrentProductInformation.js'

export const PlanCard = () => {
  const { currentInterval, currentProduct, hasPlan, isManual, planName } =
    useCurrentProductInformation()
  const { Link } = useRouter()

  if (isManual) {
    return (
      <Card>
        <Card.Header
          title={<T defaultMessage="Plan" id="Generics.Plan" />}
          description={
            <T
              defaultMessage="You are currently on manual payments, please contact support to change your plan."
              id="Admin.Billing.Plans.Manual"
            />
          }
        />
        <Card.Content className="-mt-6" />
      </Card>
    )
  }

  return (
    <Card>
      <Card.Header
        title={
          <div className="flex gap-2 items-center">
            <T
              defaultMessage="{planName} plan"
              id="Admin.Billing.Plans.CurrentPlanName"
              values={{
                planName,
              }}
            />
            {hasPlan && (
              <div className="flex flex-col">
                <Badge>
                  {currentInterval === BillingPriceInterval.Month ? (
                    <T
                      defaultMessage="Monthly"
                      id="Admin.Billing.Plans.CurrentPlanName.Monthly"
                    />
                  ) : (
                    <T
                      defaultMessage="Yearly"
                      id="Admin.Billing.Plans.CurrentPlanName.Yearly"
                    />
                  )}
                </Badge>
              </div>
            )}
          </div>
        }
        description={currentProduct?.description}
      />
      <Card.Content>
        <Divider padding="none" className="-mx-6 mb-6" />
        <Link variant="accent" href="/manage/billing/plans">
          {hasPlan ? (
            <T
              defaultMessage="Update plan"
              id="Admin.Billing.Plans.UpdatePlan"
            />
          ) : (
            <T
              defaultMessage="Choose a plan"
              id="Admin.Billing.Plans.ChoosePlan"
            />
          )}
        </Link>
      </Card.Content>
    </Card>
  )
}
